<div class="add-note-header" style="display:flex;align-items:center;gap:12px;margin-bottom:12px;">
    <button mat-icon-button class="back-button" [routerLink]="['../']" aria-label="Powrót do notatek">
        <mat-icon>arrow_back</mat-icon>
    </button>
    <h3 style="margin:0;">Dodaj Notatke:</h3>
</div>
<form class="d-flex flex-column add-note-form" (ngSubmit)="onSubmit()" [formGroup]="noteForm">
    <mat-form-field>
        <mat-label>Tytuł</mat-label>
        <input matInput class="w-50" formControlName="title">
        <mat-error *ngIf="noteForm.get('title')?.hasError('required') && noteForm.get('title')?.touched">
            Pole wymagane
        </mat-error>
    </mat-form-field>
    <mat-form-field>
        <mat-label>Treść</mat-label>
        <textarea matInput class="textarea-note"
            matTextareaAutosize
            matAutosizeMinRows="3"
            matAutosizeMaxRows="10"
            formControlName="note"></textarea>
            <mat-error *ngIf="noteForm.get('note')?.invalid">
                Pole wymagane
            </mat-error>
    </mat-form-field>
    <mat-radio-group formControlName="noteType">
        <mat-radio-button value="note">Notatka</mat-radio-button>
        <mat-radio-button value="service_entry">Wpis serwisowy</mat-radio-button>
    </mat-radio-group>
        <input type="file"
         #fileInput 
         (change)="onFileSelected($event)" 
         accept="image/*,application/pdf" 
         hidden
         multiple>

        <!-- Button do otwierania okna wyboru pliku -->
        <button mat-button type="button" (click)="fileInput.click()">
            Dodaj załącznik
        </button>

        <!-- Wyświetlenie nazwy wybranego pliku -->
         <div *ngFor="let file of selectedFiles">
            <span>{{ file.name }}</span> <button mat-icon-button color="warn" type="button" (click)="onDeleteFile(file)" aria-label="Usuń plik">
                <mat-icon>close</mat-icon>
            </button> 
         </div>
        
        <div class="form-actions">
            <button mat-flat-button color="primary" type="submit" class="submit-button" [disabled]="!noteForm.valid">Dodaj</button>
        </div>
    </form>